<template>
  <div class="t9_order">
    <div class="menu-layer">
      <div class="menu-item border-bottom" @click="clickMenu(1)">
        <img src="http://assets.rurushishi.com/yq-rs-make/huafa/youhuikaquan.png" />
        <div class="title">优惠卡券</div>
      </div>
      <div class="menu-item" @click="clickMenu(2)">
        <img src="http://assets.rurushishi.com/yq-rs-make/huafa/fangyuandingdan.png" />
        <div class="title">房源订单</div>
      </div>
    </div>
    <BtnBackLayout4></BtnBackLayout4>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
import * as comreq from "@/utils/comreq";
import Cookies from "js-cookie";
const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
export default {
  components: {
    BtnBackLayout4
  },
  props: {},
  data() {
    return {
      isSale: false,
      projectList: []
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo"
    ])
  },
  methods: {
    clickMenu(type) {
      let initObj = Cookies.get("t9_20200131_init");
      if (initObj) {
        initObj = JSON.parse(initObj);
      }      
      if(type == 1) {
        //卡劵
        let appid = this.global.APPID;
        let openid = Cookies.get("openid");
        let backurl = `${location.protocol}//${location.host}/h5/t9_my?id=${initObj.id}&psn=${initObj.psn}`;
        // 如果有传播者也一并把传播者传到打开的页面
        if (this.receiveSpreadInfo.refereeopenid) {
          backurl += `&refereeopenid=${this.receiveSpreadInfo.refereeopenid}`;
        }
        if (this.receiveSpreadInfo.rscuid) {
          backurl += `&rscuid=${this.receiveSpreadInfo.rscuid}`;
        }
        let url = `${
          location.protocol
        }//${appid}.web.ruthyx.com/act/online/rs-h5-t9-coupon/rs-h5-t9-coupon.html#/coupon-list?o=${openid}&backurl=${encodeURIComponent(
          backurl
        )}`;
        util.openUrl(url);
      }
      if(type == 2) {
        //房源订单
        if(this.isInMiniProgram) {        
          let url = `${location.protocol}//${location.host}/h5/t9_selpro`;
          util.openYqRsMakeLink(url);
        } else {
          this.$router.push("t9_selpro");
        }         
      }
    }
  },
  created() {
    // util.checkMapStateCallback(this, ["pageInfo", "userInfo"]).then(() => {
    //   // 是否注册过
    //   comreq.getUserIntegralInfo().then(userInfo => {
    //     // 销售
    //     if (userInfo.isSale == true) {
    //       this.isSale = true
    //     }
    //   });
    // });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.menu-layer .menu-item {
  line-height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.2rem;
  background: url("https://assets.rurushishi.com/yq-rs-make/sysintro/arrow.png")
    no-repeat right 10px center;
  background-size: 0.2rem 0.2rem;
}
.menu-layer .menu-item > img {
  display: block;
  width: 0.42rem;
  height: 0.42rem;
  margin-top: -2px;
}
.menu-layer .menu-item .title {
  padding-left: 0.1rem;
  font-size: 0.28rem;
  color: #333333;
  flex: 1;
}
</style>